import { TextField, Box, Typography } from "@mui/material";
import MoedaInput from "../../../../util/ui/inputs/moedaInput";

type Props = {
  irrf: number;
  irrfDaytrade: number;
  iss: number;
};

export default function CustosCorretagem({ irrf, irrfDaytrade, iss }: Props) {
  return (
    <Box
      display={"flex"}
      flexDirection="column"
      width="100%"
      paddingX={1}
      paddingY={2}
    >
      {/* Section header do sistema: eyebrow mono tracked sobre hairline. */}
      <Box
        borderBottom={1}
        borderColor="divider"
        paddingBottom={1}
        marginBottom={1.5}
      >
        <Typography variant="eyebrow" color="text.secondary">
          Corretagem e impostos
        </Typography>
      </Box>
      <Box
        display={"flex"}
        flexDirection="row"
        justifyContent={"space-between"}
        alignItems="center"
      >
        <Box flexBasis="75%" paddingRight={1}>
          <Typography variant="labelMono" color="text.secondary">
            I.R.R.F.
          </Typography>
        </Box>

        <TextField
          id="standard-irrf"
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          value={irrf}
          disabled={true}
          InputProps={{
            inputComponent: MoedaInput,
          }}
        />
      </Box>
      <Box
        display={"flex"}
        flexDirection="row"
        justifyContent={"space-between"}
        alignItems="center"
        paddingTop={1}
      >
        <Box flexBasis="75%" paddingRight={1}>
          <Typography variant="labelMono" color="text.secondary">
            I.R.R.F. Daytrade
          </Typography>
        </Box>

        <TextField
          id="standard-irrfDaytrade"
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          value={irrfDaytrade}
          disabled={true}
          InputProps={{
            inputComponent: MoedaInput,
          }}
        />
      </Box>
      <Box
        display={"flex"}
        flexDirection="row"
        justifyContent={"space-between"}
        alignItems="center"
        paddingTop={1}
      >
        <Box flexBasis="75%" paddingRight={1}>
          <Typography variant="labelMono" color="text.secondary">
            ISS (Impostos)
          </Typography>
        </Box>

        <TextField
          id="standard-iss"
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          value={iss}
          disabled={true}
          InputProps={{
            inputComponent: MoedaInput,
          }}
        />
      </Box>
    </Box>
  );
}
